<script>
    import R, {LOADER} from "../lib/requests";
    import app from '../stores/app';
    import user from '../stores/user';
    import {USER_ROLE, USER_ROLES} from "../lib/constants";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let userId = null;
    export let agentId = null;
    export let closeCallback;

    let userData = null;
    let changePassword = false;
    let title = "User account";

    const initialize = () => {
        if (userId == 0) {
            userData = {
                id: 0,
                agent_id: agentId,
                name: '',
                mobile: '',
                email: '',
                password: '',
                role: USER_ROLE.AGENT,
                is_active: 1,
            }
            if (!agentId) {
                title = "New user account";
            } else {
                title = "Add user to agent";
            }
            setFocusTo('userName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            userData = result;
            userData.role = ~~userData.role;

            setFocusTo('userName');
        };

        const onFailure = err => {
        };

        R.handle(R.user.details, userId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("User account updated!");
            close(result);
        }

        const onFailure = err => {
            console.log(err);
            if (err.message) {
                Notifier.showError(err.message);
                if (err.code == 'user_account_exist') {
                    setFocusTo("userEmail");
                }
            }
        };


        userData.name = userData.name.trim();
        userData.email = userData.email.trim();
        if (!userData.name) {
            Notifier.showError("Type the name of the user!");
            setFocusTo("userName");
            return;
        }
        if (userData.role == USER_ROLE.AGENT) {
            if (userData.agent_id == 0) {
                Notifier.showError("Select agency for this user!");
                setFocusTo("userAgent");
                return;
            }
        } else {
            userData.agent_id = 0;
        }
        if (!userData.email) {
            Notifier.showError("Type the user account email!");
            setFocusTo("userEmail");
            return;
        }
        if (userData.id == 0 && !userData.password) {
            Notifier.showError("Type the user account password!");
            setFocusTo("password");
            return;
        }
        if (changePassword && !userData.password) {
            Notifier.showError("Type the new password for this account!");
            setFocusTo("newPassword");
            return;
        }

        if (userData.id > 0 && !changePassword) {
            delete (userData.password);
        }

        let action = userId == 0 ? 'create' : 'edit';
        R.handle(R.user[action], userData, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        userData = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const toggleChangePassword = () => {
        changePassword = !changePassword;
        if (changePassword) {
            setFocusTo("newPassword");
        } else {
            delete (userData.password);
        }
    }

    initialize();
</script>

{#if userData}
    <Modal {title} on:close={ close }>
        <div slot="body">
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="userName" bind:value="{ userData.name }">
            </div>
            <div class="form-group">
                <label>Type</label>
                <select class="form-select" bind:value={userData.role} disabled={userData.id == 1 || agentId != null}>
                    {#each USER_ROLES as role, index}
                        {#if index > 0}
                            <option value="{index}">{role}</option>
                        {/if}
                    {/each}
                </select>
            </div>
            {#if userData.role === USER_ROLE.AGENT}
                <div class="form-group">
                    <label>Agency</label>
                    <select class="form-select" id="userAgent" bind:value="{userData.agent_id}" disabled={agentId != null}>
                        <option value="0">... select agent ...</option>
                        {#each $app.agents as agent}
                            <option value="{agent.id}">{agent.name}</option>
                        {/each}
                    </select>
                </div>
            {/if}
            <div class="form-group">
                <label>Mobile</label>
                <input type="tel" class="form-control" bind:value="{ userData.mobile }">
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="userEmail" bind:value="{ userData.email }">
            </div>
            {#if userData.id == 0}
                <div class="form-group">
                    <label>Password</label>
                    <input type="text" class="form-control" id="password" bind:value="{ userData.password }">
                </div>
            {:else}
                {#if !changePassword}
                    <div class="form-group">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Change password
                        </button>
                    </div>
                {:else}
                    <div class="form-group">
                        <label>New password</label>
                        <input type="text" class="form-control" id="newPassword" bind:value="{ userData.password }">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Do not change password
                        </button>
                    </div>
                {/if}
            {/if}
            {#if userData.id != $user.id && userData.id != 1}
                <Checkbox label="Active account" bind:checked="{userData.is_active}" />
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Update</button>
            </div>
        </div>
    </Modal>
{/if}